import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12c9d4e6")

_pushScopeId("data-v-12c9d4e6")
const _hoisted_1 = {
  key: 0,
  class: "home__img",
  src: "/images/home/home4.jpg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "overlay" }, null, -1)
const _hoisted_3 = { class: "sponsor__content" }
const _hoisted_4 = {
  key: 0,
  class: "catchphrase"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "catchphrase__title" }, [
  /*#__PURE__*/_createVNode("div", { class: "text" }, " Merci à tous nos commanditaires! ")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "loading__container"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_8 = {
  key: 2,
  class: "no-data"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Aucun commanditaire enregistré", -1)
const _hoisted_11 = { class: "sponsors__wrapper scrollbar--invisible" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SponsorCard = _resolveComponent("SponsorCard")

  return (_openBlock(), _createBlock("div", {
    class: "sponsors",
    style: _ctx.viewportHeight
  }, [
    (_ctx.showImg)
      ? (_openBlock(), _createBlock("img", _hoisted_1))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_ctx.showTitle)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7
          ]))
        : (!_ctx.sponsors.length)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10
            ]))
          : _createCommentVNode("", true),
      _createVNode("div", _hoisted_11, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sponsors, (sponsor, ix) => {
          return (_openBlock(), _createBlock(_component_SponsorCard, {
            id: encodeURI(sponsor.name),
            key: ix,
            sponsor: sponsor
          }, null, 8, ["id", "sponsor"]))
        }), 128))
      ]),
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
    ])
  ], 4))
})